import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';

import {
  PaginateUsersState,
} from 'store/ducks/settings/users';

import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridUsers, FilterUsers, ImpersonateModal } from 'components/settings';
import { useFilters } from 'hooks/useFilters';

export const ListUsers: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { setFilter, filters } = useFilters('users');

  const [openModalImpersonate, setOpenModalImpersonate] = useState(false);
  const [impersonateEmail, setImpersonate] = useState('');
  const { data, loading, pagination } = useSelector<
    RootStateOrAny,
    PaginateUsersState
  >((state) => state.paginateUsers);

  const HandlerModalImpersonate = useCallback((email: string) => {
    setImpersonate(() => email);
    setOpenModalImpersonate(() => true);
  }, []);

  useEffect(() => {
    setFilter({ ...filters, includeDeleted: true });
  }, []);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="users" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertUser') && (
            <S.ButtonMini onClick={() => history.push('/settings/user/new')}>
              {getTranslation('novoUsuario')}
            </S.ButtonMini>
          )}
          <FilterUsers />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridUsers users={data} onImpersonate={HandlerModalImpersonate} />
        <Paginator
          pagination={pagination}
          settingsPage='users'
          loading={loading}
        />

        {openModalImpersonate && (
          <ImpersonateModal
            openModal={openModalImpersonate}
            email={impersonateEmail}
            close={() => setOpenModalImpersonate(false)}
          />
        )}
      </S.PageContent>
    </MainContainer>
  );
};
